import React from "react";
import { useState } from "react";
import usePostCsvLock from "./hooks/usePostCsvLock";
import { useSnackbar } from "notistack";
import { SiteSystemType } from "api/ApiClient";
import { CsvLockUploadPayload } from "./hooks/usePostCsvLock";
import { Button } from "components/ui/button";
type Props = {
  isDisabled: boolean;
  siteId: string;
  onHide: () => void;
  systemType?: SiteSystemType | null;
};
export const CSVLockUploaderModal = ({
  isDisabled,
  siteId,
  onHide,
  systemType,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  let findError: any = "";
  let errorMessage: any = "";
  const [selectedFile, setSelectedFile] = useState<File | undefined>();
  const [propertyExternalIdOverride, setPropertyExternalIdOverride] =
    useState("");
  const [propertyNameOverride, setPropertyNameOverride] = useState("");
  const { mutateAsync, isPending, isError, error } = usePostCsvLock(siteId);
  const getImage = (e: any) => {
    e.preventDefault();
    setSelectedFile(e.target.files[0]);
  };

  const registerLock = (e: any) => {
    e.preventDefault();

    if (selectedFile) {
      const payload: CsvLockUploadPayload = {
        file: selectedFile,
      };
      if (systemType === SiteSystemType.DormaKaba) {
        if (propertyExternalIdOverride.trim()) {
          payload.propertyExternalIdOverride =
            propertyExternalIdOverride.trim();
        }
        if (propertyNameOverride.trim()) {
          payload.propertyNameOverride = propertyNameOverride.trim();
        }
      }
      mutateAsync(payload, {
        onSuccess() {
          enqueueSnackbar(
            <p style={{ fontSize: "12px", padding: 0, margin: 0 }}>
              File uploaded successfully
            </p>,
            {
              variant: "success",
            },
          );
          onHide();
        },
      });
    }
  };

  if (isError) {
    findError = error;
    errorMessage = findError.response.data.message || "Something went wrong.";
  }

  return (
    <form style={{ margin: "20px" }}>
      {isError && errorMessage && (
        <p style={{ padding: "5px", backgroundColor: "#F67280" }}>
          {errorMessage}
        </p>
      )}
      <div className="form-group">
        <label htmlFor="lockName">Upload CSV *</label>
        <input
          className="form-control"
          name="file"
          type="file"
          accept=".csv"
          onChange={getImage}
        />
      </div>
      {systemType === SiteSystemType.DormaKaba && (
        <>
          <div className="form-group">
            <label htmlFor="propertyExternalIdOverride">
              Property External Id Override (optional)
            </label>
            <input
              className="form-control"
              name="propertyExternalIdOverride"
              placeholder="Override property external id"
              value={propertyExternalIdOverride}
              onChange={(e) => setPropertyExternalIdOverride(e.target.value)}
            />
          </div>
          <div className="form-group">
            <label htmlFor="propertyNameOverride">
              Property Name Override (optional)
            </label>
            <input
              className="form-control"
              name="propertyNameOverride"
              placeholder="Override property name"
              value={propertyNameOverride}
              onChange={(e) => setPropertyNameOverride(e.target.value)}
            />
          </div>
        </>
      )}
      <div>
        <p>
          <b>Note:</b>
        </p>
        <p>
          CSV need to contain the following fields:{" "}
          <b>SystemLockId, Lock Name, Unit Number, Door Type</b>
        </p>
      </div>

      <div>
        <Button
          type="submit"
          disabled={isDisabled || selectedFile === undefined || isPending}
          onClick={registerLock}
        >
          {isPending ? "Please wait..." : "Upload"}
        </Button>
      </div>
    </form>
  );
};
